function mapFilterOperatorToRestOperator(filterOperator: string): string {
  switch (filterOperator) {
    case 'similar':
      return 'iexact';
    case 'contains':
      return 'icontains';
    case 'isOneOf':
      return 'in';
    default:
      return filterOperator;
  }
}

export type FilterParams = Record<
  string,
  Partial<{
    between: Array<unknown>;
    [key: string]: unknown;
  }>
>;

export function mapFilterToRestParams(
  filter: FilterParams = {},
): Record<string, string> {
  const restParams: Record<string, string> = {};
  const addToRestParams = (
    fieldName: string,
    operator: string,
    operand: NonNullable<unknown>,
  ) => {
    let filterKey;
    let filterValue;
    if (operator === 'equals') {
      filterKey = fieldName;
      filterValue = operand;
    } else if (operator === 'is') {
      // boolean
      filterKey = fieldName;
      filterValue = operand ? 'True' : 'False';
    } else {
      const restOperator = mapFilterOperatorToRestOperator(operator);
      filterKey = `${fieldName}__${restOperator}`;
      filterValue = operand;
    }
    restParams[filterKey] = filterValue.toString();
  };
  Object.entries(filter).forEach(([oneFieldName, filterValue]) => {
    Object.entries(filterValue).forEach(([oneOperator, operand]) => {
      if (operand !== undefined && operand !== null) {
        if (oneOperator === 'between' && Array.isArray(operand)) {
          // isDual
          addToRestParams(oneFieldName, 'gte', operand[0]);
          addToRestParams(oneFieldName, 'lte', operand[1]);
        } else {
          addToRestParams(oneFieldName, oneOperator, operand);
        }
      }
    });
  });
  return restParams;
}

function mapFieldsToRestParams(fields: unknown): {fields: string} | null {
  return fields
    ? {
        fields: fields.toString(),
      }
    : null;
}

function mapSortByToRestParam(sortBy: Array<string>) {
  return sortBy.reduce((str, sortByElement, i) => {
    const order = sortByElement.substr(0, 1);
    const field = sortByElement.substr(1);
    return str + (i === 0 ? '' : ',') + (order === '-' ? '-' : '') + field;
  }, '');
}

export type QueryParams = Partial<{
  filter: FilterParams;
  sortBy: Array<string>;
  [key: string]: unknown;
}>;

export function mapQueryParamsToRestParams(
  queryParams: QueryParams = {},
): Record<string, unknown> {
  const restParams: Record<string, unknown> = {};
  Object.keys(queryParams).forEach(oneKey => {
    switch (oneKey) {
      case 'filter':
        Object.assign(restParams, mapFilterToRestParams(queryParams.filter));
        break;
      case 'geomFilter':
        Object.assign(restParams, queryParams.geomFilter);
        break;
      case 'inseeCode':
        restParams.insee_code = queryParams.inseeCode;
        break;
      case 'fields':
        Object.assign(restParams, mapFieldsToRestParams(queryParams.fields));
        break;
      case 'sortBy':
        restParams.ordering = mapSortByToRestParam(queryParams.sortBy ?? []);
        break;
      default:
        restParams[oneKey] = queryParams[oneKey];
    }
  });
  return restParams;
}
